var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo-link",attrs:{"to":_vm.$store.getters['header/getFirstChapterRoute']}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo_short.svg")}}),_c('div',{staticClass:"logo-title"},[_c('div',{staticClass:"one-row-lt"},[_vm._v("СЭД Интегро")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }